<template>
  <div class="container-fluid">
    <b-form
      class="o-form"
      novalidate
      autocomplete="off"
      @submit="onSubmit"
      @reset="onReset"
    >
      <!----------------------- Buttons ------------------------------>
      <b-row class="pt-4 pb-4">
        <b-col>
          <b-button
            size="sm"
            class="o-save"
            type="submit"
            variant="primary"
          >
            <i class="fa fa-floppy-o" />&nbsp; SAVE
          </b-button>
          <b-button
            size="sm"
            class="o-cancel"
            type="reset"
            variant="danger"
          >
            <i class="fa fa-times" />&nbsp; CANCEL
          </b-button>
        </b-col>
      </b-row>

      <b-row v-if="validationError.message">
        <b-col>
          <div>
            <h2>{{ validationError.message }}</h2>
            <ul
              v-for="error in validationError.errors"
              :key="error.field"
            >
              <li>{{ error.field }} {{ error.messages }}</li>
            </ul>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          class="my-2"
          lg="4"
          md="12"
        >
          <b-form-group
            class="o-field"
            :state="nameState"
          >
            <label for="tenantName">Name</label>
            <b-form-input
              id="tenantName"
              v-model="form.name"
              placeholder="Name"
              :state="nameState"
              trim
              @keyup="throttledMethod(validateUniqueName)"
            />
            <div class="invalid-tooltip">
              {{ nameInvalidFeedback }}
            </div>
          </b-form-group>
        </b-col>
        <b-col
          class="my-2"
          lg="4"
          md="12"
        >
          <b-form-group
            class="o-field"
            :state="subdomainState"
          >
            <label for="tenantSubdomain">Subdomain</label>
            <b-form-input
              id="tenantSubdomain"
              v-model="form.subdomain"
              placeholder="Subdomain"
              :state="subdomainState"
              trim
              @keyup="throttledMethod(validateUniqueSubdomain)"
            />
            <div class="invalid-tooltip">
              {{ subdomainInvalidFeedback }}
            </div>
          </b-form-group>
        </b-col>
        <b-col
          class="my-2"
          lg="4"
          md="12"
        >
          <b-form-group
            class="o-field"
            :state="tenantIdState"
          >
            <label for="tenantId">Tenant ID</label>
            <b-form-input
              id="tenantId"
              v-model="form.tenantId"
              required
              placeholder="Tenant ID"
              :state="tenantIdState"
              trim
              @keyup="throttledMethod(validateUniqueTenantId)"
            />
            <div class="invalid-tooltip">
              {{ tenantIdInvalidFeedback }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          class="my-2"
          lg="4"
          md="12"
        >
          <b-form-group class="o-field">
            <label for="tenantIdentityProvider">Identity Provider</label>
            <b-select
              id="tenantIdentityProvider"
              v-model="form.identityProvider"
              placeholder="Select"
              :options="identityProviderOptions"
              @change="setIdentityProviderTemplate"
            />
          </b-form-group>
        </b-col>
        <b-col
          class="my-2"
          lg="4"
          md="12"
        >
          <b-form-group class="o-field">
            <label for="tenantCorePlatform">Core Platform</label>
            <b-select
              id="tenantCorePlatform"
              v-model="form.corePlatform"
              placeholder="Select"
              :options="corePlatformOptions"
            />
          </b-form-group>
        </b-col>
        <b-col
          class="my-2"
          lg="4"
          md="12"
        >
          <b-form-group class="o-field">
            <label for="tenantVerticalMarket">Vertical Market</label>
            <b-select
              id="tenantVerticalMarket"
              v-model="form.verticalMarket"
              placeholder="Select"
              :options="verticalMarketOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="o-field">
            <label
              for="tenantIdentityProviderSettings"
            >Identity Provider Settings</label>
            <b-form-textarea
              id="tenantIdentityProviderSettings"
              v-model="form.identityProviderSettings"
              rows="10"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="form.identityProvider == 1">
        <b-col>
          <b-form-group class="o-field">
            <label for="customLogoUri">Custom Logo URI</label>
            <b-form-input
              id="customLogoUri"
              v-model="form.customLogoUri"
              placeholder="Custom Logo URI"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <client-express-config
        v-if="this.$route.path === '/tenants/new'"
        :data="clientExpressConfig"
        :subdomain="form.subdomain"
        @reportexec-baseurl-changed="handleReportExecBaseUrlChanged"
      />

      <!----------------------- Buttons ------------------------------>
      <b-row class="pt-3">
        <b-col>
          <b-alert
            v-model="showAlert"
            variant="danger"
            dismissible
          >
            {{ alertMessage }}
          </b-alert>
        </b-col>
      </b-row>

      <b-row class="pt-4 pb-4 justify-content-around">
        <b-col>
          <b-button
            size="sm"
            class="o-save"
            type="submit"
            variant="primary"
          >
            <i class="fa fa-floppy-o" />&nbsp; SAVE
          </b-button>
          <b-button
            size="sm"
            class="o-cancel"
            type="reset"
            variant="danger"
          >
            <i class="fa fa-times" />&nbsp; CANCEL
          </b-button>
        </b-col>
      </b-row>

      <b-row v-if="validationError.message">
        <b-col>
          <div>
            <h2>{{ validationError.message }}</h2>
            <ul
              v-for="error in validationError.errors"
              :key="error.field"
            >
              <li>{{ error.field }} {{ error.messages }}</li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ClientExpressConfig from "@/components/tenants/clients/ClientExpressConfig.vue";
import ClientExpressConfigJsonData from "@/components/tenants/clients/ClientExpressConfig.json";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "TenantDetailForm",
  components: {
    ClientExpressConfig,
  },
  data() {
    return {
      isNameUnique: true,
      isSubdomainUnique: true,
      isTenantIdUnique: true,
      validationError: { message: "", errors: [] },
      form: {
        id: 0,
        name: "",
        tenantId: "",
        subdomain: "",
        identityProviderSettings: "",
        identityProvider: 0,
        corePlatform: 0,
        verticalMarket: 0,
        customLogoUri: ""
      },
      clientExpressConfig: this.initializeClientData(),
      identityProviderOptions: [
        { value: 0, text: "" },
        { value: 1, text: "Omnigo" },
        { value: 2, text: "OpenID Connect" },
        { value: 3, text: "Windows Authentication" },
      ],
      corePlatformOptions: [
        { value: 0, text: "Other" },
        { value: 1, text: "Report Exec" },
        { value: 2, text: "ITI" },
        { value: 3, text: "iTrak" },
        { value: 4, text: "CleanTraq" },
        { value: 5, text: "Omnigo" },
      ],
      verticalMarketOptions: [
        { value: 0, text: "Other" },
        { value: 1, text: "Law Enforcement" },
        { value: 2, text: "Healthcare" },
        { value: 3, text: "Gaming" },
        { value: 4, text: "Hospitality" },
        { value: 5, text: "Corporate" },
        { value: 6, text: "Higher Education" },
        { value: 7, text: "K12 Schools" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
    }),
    showAlert: {
      get() {
        return this.$store.getters.showAlert;
      },
      set(value) {
        this.$store.dispatch("showAlert", value);
      },
    },
    alertMessage: {
      get() {
        return this.$store.getters.alertMessage;
      },
      set(value) {
        this.$store.dispatch("alertMessage", value);
      },
    },
    // Validation - Name Field
    nameState() {
      return this.isNameUnique && this.form.name.length >= 4 ? true : false;
    },
    nameInvalidFeedback() {
      if (this.form.name.length >= 4 && this.isNameUnique) {
        return "";
      } else if (this.form.name.length < 4) {
        return "Enter at least 4 characters";
      } else if (this.form.name.length >= 4 && !this.isNameUnique) {
        return "Must be unique across all Tenants";
      } else {
        return "Required";
      }
    },
    // Validation - Subdomain Field
    subdomainState() {
      return this.isSubdomainUnique && this.form.subdomain.length >= 3
        ? true
        : false;
    },
    subdomainInvalidFeedback() {
      if (this.form.subdomain.length >= 3 && this.isSubdomainUnique) {
        return "";
      } else if (this.form.subdomain.length < 3) {
        return "Enter at least 3 characters";
      } else if (this.form.subdomain.length >= 3 && !this.isSubdomainUnique) {
        return "Must be unique across all Tenants";
      } else {
        return "Required";
      }
    },
    subdomainValidFeedback() {
      return "";
    },
    // Validation - TenantId Field
    tenantIdState() {
      return this.isTenantIdUnique && this.form.tenantId.length >= 12
        ? true
        : false;
    },
    tenantIdInvalidFeedback() {
      if (this.form.tenantId.length >= 12 && this.isTenantIdUnique) {
        return "";
      } else if (this.form.tenantId.length < 12) {
        return "Enter at least 12 characters";
      } else if (this.form.tenantId.length >= 12 && !this.isTenantIdUnique) {
        return "Must be unique across all Tenants";
      } else {
        return "Required";
      }
    },
    tenantIdValidFeedback() {
      return "";
    },
  },
  created() {
    this.loadTenant();
  },
  methods: {
    handleReportExecBaseUrlChanged(baseUrl) {
      if(baseUrl && baseUrl.length && this.form.identityProvider == 1){
        this.form.customLogoUri = `${baseUrl}/cesireportexec/api/SystemSettings/getCustomLogo`;
      }
    },
    normalizeNibrsMfeUrlByEnvironment(url) {
      var newUrl = "";
      if (window.location.origin.includes("localhost"))
        newUrl = url.replace("https://nibrsmfe.omnigo.one", window.location.origin);
      else if (window.location.origin.includes("-dev"))
        newUrl = url.replace("nibrsmfe", "nibrsmfe-dev");
      else if (window.location.origin.includes("-qa"))
        newUrl = url.replace("nibrsmfe", "nibrsmfe-qa");
      else
        newUrl = url;
      return newUrl;
    },
    getRedirectUri(summary, baseUrl) {
      if (summary.clientName === "WebDispatch") {
        let webDispatchUri = (summary.webDispatchUri.endsWith("/") ? summary.webDispatchUri.substring(0, summary.webDispatchUri.length - 1) : summary.webDispatchUri);
        return webDispatchUri + summary.redirectUri;
      } else if (summary.clientName === "Omnigo Console") {
        const subdomain = this.getSubDomain(baseUrl);
        const env = this.getEnv();
        return `https://${subdomain}${env}.apps.omnigo.one/signin-oidc-${subdomain}`;
      } else {
        return (summary.requireClientSecret ? baseUrl : "") + this.normalizeNibrsMfeUrlByEnvironment(summary.redirectUri);
      }
    },
    getPostLogoutRedirectUri(summary, baseUrl) {      
      if (summary.clientName === "WebDispatch") {
        let webDispatchUri = (summary.webDispatchUri.endsWith("/") ? summary.webDispatchUri.substring(0, summary.webDispatchUri.length - 1) : summary.webDispatchUri);
        return webDispatchUri;
      } else if (summary.clientName === "Omnigo Console") {
        const subdomain = this.getSubDomain(baseUrl);
        const env = this.getEnv();
        return `https://${subdomain}${env}.apps.omnigo.one/signout-oidc-${subdomain}`;
      } else {
        return (summary.requireClientSecret ? baseUrl : "") + summary.postLogoutRedirectUri;
      }
    },
    getAllowedCorsOrigin(summary, url) {
      if (summary.clientName === "WebDispatch") {
        let webDispatchUri = (summary.webDispatchUri.endsWith("/") ? summary.webDispatchUri.substring(0, summary.webDispatchUri.length - 1) : summary.webDispatchUri);
        return webDispatchUri;
      } else {
        return this.normalizeNibrsMfeUrlByEnvironment(url);
      }
    },
    clearValidationErrors() {
      this.validationError = { message: "", errors: [] };
    },
    loadTenant() {
      if (this.$route.params.tenantId > 0) {
        this.$axios
          .get(`/api/tenants/${this.$route.params.tenantId}`)
          .then((response) => {
            this.form = response.data;
            if (this.form.identityProviderSettings !== "") {
              var jsonPretty = JSON.stringify(
                JSON.parse(this.form.identityProviderSettings),
                null,
                2
              );
              this.form.identityProviderSettings = jsonPretty;
            }
          })
          .catch((error) => {
            this.alertMessage = error;
          });
      } else {
        this.$axios
          .get(`/api/tenants/newTenantId`)
          .then((response) => {
            this.form.tenantId = response.data;
          })
          .catch(() => {});
      }
    },
    isFormValid() {
      return (
        this.nameState &&
        this.subdomainState &&
        this.tenantIdState &&
        this.isClientExpressConfigValid()
      );
    },
    isClientExpressConfigValid() {
      const platforms = this.clientExpressConfig.platforms;

      for (let i = 0; i < platforms.length; i++) {
        const platform = platforms[i];

        if (!platform.inUse) {
          continue;
        }

        if (platform.baseUrl.length === 0) {
          return false;
        }

        const clients = platform.clients;

        for (let j = 0; j < clients.length; j++) {
          const client = clients[j];

          if (!client.inUse) {
            continue;
          }

          if (
            client.clientId.length === 0 ||
            (client.requireClientSecret && client.clientSecret.length === 0)
          ) {
            return false;
          }
          
          if (client.clientName === "WebDispatch" && (!client.webDispatchUri || !client.webDispatchUri.length)) {
            return false;
          }
        }
      }

      return true;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.clearValidationErrors();
      if (this.isFormValid()) {
        if (this.$route.params.tenantId === undefined) {
          this.createTenant();
        } else {
          this.updateTenant();
        }
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.$router.push({ name: "tenants" });
    },
    createTenant() {
      const tenant = JSON.parse(JSON.stringify(this.form));
      tenant.clients = this.createClients();

      this.$axios
        .post("/api/tenants/new", tenant)
        .then(
          (response) => {
            console.log("Success => " + response);
            this.$router.push({ name: "tenants" });
          },
          (error) => {
            console.log("Error => " + JSON.stringify(error.response.data));
            this.validationError = error.response.data;
          }
        )
        .catch((ex) => {
          this.alertMessage = ex;
        });
    },
    updateTenant() {
      this.$axios
        .put(`/api/tenants/${this.$route.params.tenantId}/edit`, this.form)
        .then(() => {
          this.$router.push({ name: "tenants" });
        })
        .catch((error) => {
          this.alertMessage = error;
        });
    },
    createClients() {
      const platforms = this.clientExpressConfig.platforms;
      const newClients = [];

      for (let i = 0; i < platforms.length; i++) {
        const platform = platforms[i];

        if (!platform.inUse) {
          continue;
        }

        const clients = platform.clients;

        for (let j = 0; j < clients.length; j++) {
          const client = clients[j];

          if (client.inUse) {
            newClients.push(this.createClient(client, platform.baseUrl));
          }
        }
      }

      return newClients;
    },
    createClient(summary, baseUrl) {
      if (baseUrl && baseUrl.substring(baseUrl.length - 1) === "/") {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1);
      }

      const client = {
        enabled: true,
        clientId: summary.clientId,
        protocolType: "oidc",
        requireClientSecret: summary.requireClientSecret,
        clientName: summary.clientName,
        description: summary.clientName,
        clientUri: null,
        logoUri: null,
        requireConsent: false,
        allowRememberConsent: true,
        alwaysIncludeUserClaimsInIdToken:
          summary.alwaysIncludeUserClaimsInIdToken,
        requirePkce: summary.requirePkce,
        allowPlainTextPkce: false,
        allowAccessTokensViaBrowser: false,
        frontChannelLogoutUri: null,
        frontChannelLogoutSessionRequired: true,
        backChannelLogoutUri: null,
        backChannelLogoutSessionRequired: true,
        allowOfflineAccess: summary.allowOfflineAccess,
        identityTokenLifetime: summary.identityTokenLifetime || 1200,
        accessTokenLifetime: summary.accessTokenLifetime || 3600,
        authorizationCodeLifetime: 300,
        consentLifetime: null,
        absoluteRefreshTokenLifetime: 2592000,
        slidingRefreshTokenLifetime: 1296000,
        refreshTokenUsage: 1,
        updateAccessTokenClaimsOnRefresh: false,
        refreshTokenExpiration: 1,
        accessTokenType: 0,
        enableLocalLogin: true,
        includeJwtId: false,
        alwaysSendClientClaims: false,
        clientClaimsPrefix: "client_",
        pairWiseSubjectSalt: null,
        userSsoLifetime: null,
        userCodeType: null,
        deviceCodeLifetime: 300,
        nonEditable: false,
        dPoPClockSkew: "00:00:00",
        dPoPValidationMode: 0,
        requireDPoP: false,
        pushedAuthorizationLifetime: null,
        requirePushedAuthorization: false,
        initiateLoginUri: null,
        redirectUris: [
          {
            id: 0,
            redirectUri: this.getRedirectUri(summary, baseUrl),
          },
        ],
        postLogoutRedirectUris: [
          {
            id: 0,
            postLogoutRedirectUri: this.getPostLogoutRedirectUri(summary, baseUrl)
          },
        ],
        allowedGrantTypes: [],
        allowedScopes: [
          { id: 0, scope: "openid" },
          { id: 0, scope: "profile" },
        ],
        allowedCorsOrigins: [],
        clientSecrets: [],
      };

      if (summary.primaryGrantType) {
        client.allowedGrantTypes.push({
          id: 0,
          grantType: summary.primaryGrantType,
        });
      }

      if (summary.secondaryGrantType) {
        client.allowedGrantTypes.push({
          id: 0,
          grantType: summary.secondaryGrantType,
        });
      }

      summary.allowedScopes.forEach((s) => {
        client.allowedScopes.push({ id: 0, scope: s });
      });

      summary.allowedCorsOrigins.forEach((o) => {
        client.allowedCorsOrigins.push({
          id: 0,
          origin: this.getAllowedCorsOrigin(summary, o),
        });
      });

      console.log("" + window.location.origin);

      if (summary.requireClientSecret) {
        client.clientSecrets.push({
          id: 0,
          type: "SharedSecret",
          value: summary.clientSecret,
          expiration: null,
          isNew: true,
        });
      }

      return client;
    },
    throttledMethod: function (func) {
      let debounced = _.debounce(func.bind(this), 500);
      debounced();
    },
    // validation
    validateUniqueName() {
      let value = this.form.name;
      if (value.length >= 4) {
        this.$axios
          .get(`/api/tenants/${this.form.id}/isUnique/name/${value}`)
          .then((response) => {
            this.validationError = response.data;
            this.isNameUnique = response.data.valid;
            console.log("Result = " + this.isNameUnique);
          })
          .catch((error) => {
            this.alertMessage = error;
          });
      }
    },
    validateUniqueSubdomain() {
      let value = this.form.subdomain;
      if (value.length >= 4) {
        this.$axios
          .get(`/api/tenants/${this.form.id}/isUnique/subdomain/${value}`)
          .then((response) => {
            this.validationError = response.data;
            this.isSubdomainUnique = response.data.valid;
            console.log("Result = " + this.isSubdomainUnique);
          })
          .catch((error) => {
            this.alertMessage = error;
          });
      }
    },
    validateUniqueTenantId() {
      let value = this.form.tenantId;
      if (value.length >= 4) {
        this.$axios
          .get(`/api/tenants/${this.form.id}/isUnique/tenantid/${value}`)
          .then((response) => {
            this.validationError = response.data;
            this.isTenantIdUnique = response.data.valid;
            console.log("Result = " + this.isTenantIdUnique);
          })
          .catch((error) => {
            this.alertMessage = error;
          });
      }
    },
    setIdentityProviderTemplate(selectedIndex) {
      switch (selectedIndex) {
        case 1: // Omnigo
          this.form.identityProviderSettings = this.prettyPrintJson(
            '{"ValidateCredentialsEndpoint": ""}'
          );
          break;
        case 2: // OpenIdConnect
          this.form.identityProviderSettings = this.prettyPrintJson(
            '{"Provider": "","Authority": "","ClientId": "","ClientSecret": "","LogoutUriOverride": "","TrackIdTokenForSignout":false,"TranslateExternalIdentifierEndpoint": "","ExternalIdentifierClaimType": ""}'
          );
          break;
        case 3: // WindowsAuth
          this.form.identityProviderSettings = this.prettyPrintJson("");
          break;
        default:
          // Blank
          this.form.identityProviderSettings = this.prettyPrintJson("");
      }
    },
    prettyPrintJson(jsonString) {
      if (
        jsonString === undefined ||
        jsonString === null ||
        jsonString === ""
      ) {
        jsonString = "{}";
      }
      return JSON.stringify(JSON.parse(jsonString), null, 2);
    },
    initializeClientData() {
      return JSON.parse(JSON.stringify(ClientExpressConfigJsonData));
    },
    getEnv() {
      return window.location.origin.includes("-dev") 
        ? ".dev" 
        : window.location.origin.includes("-qa") 
          ? ".qa" 
          : window.location.origin.includes("-demo")
            ? ".demo"
            : ""
    },
    getSubDomain(baseUrl) {
      var parts = baseUrl.toLowerCase().replace("http://","").replace("https://","").split('.')
      return parts.length == 0 ? "<missing base url>" : parts[0]
    },
  },
};
</script>
